export default __webpack_public_path__ + "static/media/s1.f4b9e98f.jpeg";